import React from 'react';

import './style.scss';

export default function Noise() {
	return <div className="noise"></div>;
}
